import {
  GET_BASE_PACKAGES,
  UPDATE_BASE_PACKAGES,
  GET_CUSTOM_PACKAGES,
  UPDATE_CUSTOM_PACKAGES,
  SET_PACKAGES_LOADING,
  SHOW_CREATE_PACKAGE_MODAL,
  SHOW_EDIT_PACKAGE_MODAL,
  SET_PACKAGE_EDITOR_LOADING,
  SET_PACKAGE_EDITOR_ERROR,
  SAVE_PACKAGE,
  SHOW_DELETE_CONFIRMATION,
  DELETE_PACKAGE,
  SET_DELETE_LOADING,
  GET_TERRITORIES,
  UPDATE_TERRITORIES,
  GET_LEAD_SOURCES,
  UPDATE_LEAD_SOURCES,
  GET_BONUS_SUBSCRIPTION_TYPES,
  UPDATE_BONUS_SUBSCRIPTION_TYPES,
  BILLING_PACKAGE_DO_SHOW_LOG,
  BILLING_PACKAGE_LOG_SET_SHOWN,
  BILLING_PACKAGE_LOG_CHANGE_PAGE,
  BILLING_PACKAGE_LOG_SET_DATA,
  BILLING_PACKAGE_LOG_SET_IS_LOADING,
  BILLING_PACKAGE_LOG_SET_ERRORS,
} from './actionTypes';

export const getBasePackages = () => ({
  type: GET_BASE_PACKAGES,
});

export const updateBasePackages = packages => ({
  type: UPDATE_BASE_PACKAGES,
  payload: packages,
});

export const getCustomPackages = () => ({
  type: GET_CUSTOM_PACKAGES,
});

export const updateCustomPackages = packages => ({
  type: UPDATE_CUSTOM_PACKAGES,
  payload: packages,
});

export const setPackagesLoading = isLoading => ({
  type: SET_PACKAGES_LOADING,
  payload: isLoading,
});

export const showCreatePackageModal = shown => ({
  type: SHOW_CREATE_PACKAGE_MODAL,
  payload: { shown },
});

export const showEditPackageModal = (shown, packageData) => ({
  type: SHOW_EDIT_PACKAGE_MODAL,
  payload: { shown, packageData },
});

export const setPackageEditorLoading = isLoading => ({
  type: SET_PACKAGE_EDITOR_LOADING,
  payload: isLoading,
});

export const setPackageEditorError = (errorMessage, errors = []) => ({
  type: SET_PACKAGE_EDITOR_ERROR,
  payload: { message: errorMessage, errors },
});

export const savePackage = (packagePayload, isEditMode) => ({
  type: SAVE_PACKAGE,
  payload: {
    packagePayload,
    isEditMode,
  },
});

export const showDeleteConfirmation = (shown, packageData) => ({
  type: SHOW_DELETE_CONFIRMATION,
  payload: { shown, packageData },
});

export const deletePackage = packageId => ({
  type: DELETE_PACKAGE,
  payload: { packageId },
});

export const setDeleteLoading = isLoading => ({
  type: SET_DELETE_LOADING,
  payload: isLoading,
});

export const getTerritories = () => ({
  type: GET_TERRITORIES,
});

export const updateTerritories = territories => ({
  type: UPDATE_TERRITORIES,
  payload: territories,
});

export const getLeadSources = () => ({
  type: GET_LEAD_SOURCES,
});

export const updateLeadSources = leadSources => ({
  type: UPDATE_LEAD_SOURCES,
  payload: leadSources,
});

export const getBonusSubscriptionTypes = () => ({
  type: GET_BONUS_SUBSCRIPTION_TYPES,
});

export const updateBonusSubscriptionTypes = bonusSubscriptionTypes => ({
  type: UPDATE_BONUS_SUBSCRIPTION_TYPES,
  payload: bonusSubscriptionTypes,
});

export const doShowLogs = () => ({
  type: BILLING_PACKAGE_DO_SHOW_LOG,
});

export const setLogModalShown = shown => ({
  type: BILLING_PACKAGE_LOG_SET_SHOWN,
  payload: { shown },
});

export const setLogPage = page => ({
  type: BILLING_PACKAGE_LOG_CHANGE_PAGE,
  payload: { page },
});

export const setLogData = (data, paging) => ({
  type: BILLING_PACKAGE_LOG_SET_DATA,
  payload: { data, paging },
});

export const resetLogData = () =>
  setLogData([], { page: 1, size: 20, total: 0 });

export const setLogIsLoading = isLoading => ({
  type: BILLING_PACKAGE_LOG_SET_IS_LOADING,
  payload: { isLoading },
});

export const setLogErrors = errors => ({
  type: BILLING_PACKAGE_LOG_SET_ERRORS,
  payload: { errors },
});

export const clearLogErrors = () => setLogErrors([]);
